import React, { Component } from 'react';
import './styles.css'

class Features extends Component {
  render() {
    return (
        <div className='features-container'>
        	<div className='row'>
        		<div className='col-md-3 feature-box'>
        			<div className='icon-box'>
        				<i className="feature-icon far fa-calendar"></i>
        			</div>
        			<p className='title-text'>ALTERNATIVE INVESTMENTS</p>
        			<p className='desc-text'>We are an Alternative Principle Investment firm with strong focus on private equity, mezzanine and alternative lending. We target absolute return.</p>
        		</div>
        		<div className='col-md-3 feature-box'>
        			<div className='icon-box'>
        				<i className="feature-icon fas fa-cog"></i>
        			</div>
        			<p className='title-text'>PRIVATE VC</p>
        			<p className='desc-text'>33 Ventures has an extensive network of partners across consumer tech and financial tech sectors. We focus on building strong relationships with founders to invest, advise and together grow the business as a team.</p>
        		</div>
        		<div className='col-md-3 feature-box'>
        			<div className='icon-box'>
        				<i className="feature-icon fas fa-rocket"></i>
        			</div>
        			<p className='title-text'>TECH CORPORATE ADVISORY</p>
        			<p className='desc-text'>We work with our partner companies to plan, build, transform and orchestrate an effective management strategy to help them meet and exceed their business needs and goals.</p>
        		</div>
        		<div className='col-md-3 feature-box'>
        			<div className='icon-box'>
        				<i className="feature-icon far fa-bell"></i>
        			</div>
        			<p className='title-text'>DIVIDEND GROWERS</p>
        			<p className='desc-text'>Investors seeking superior income may choose high dividend yield strategies. However, these strategies tend to have significant weightings in sectors that are highly sensitive to interest rate movements.</p>
        		</div>
        	</div>
        	<svg preserveAspectRatio="none" viewBox="0 0 100 100" height="100" width="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" id="bigTriangleDown">
        		<path d="M0 -1 L50 99 L100 -1 Z" fill="#ecf0f1"></path>
            </svg>
        </div>
    );
  }
}

export default Features;



// WEBPACK FOOTER //
// ./src/components/Features/index.js